import { useDispatch } from "react-redux";
import Button from "../Button/Button";
import Avatar from "../Avatar/Avatar";
import "./help-me-find-a-therapist.scss";
import Person1IMG from "../../../assets/images/person-1.jpg";
import Person2IMG from "../../../assets/images/person-2.jpg";
import Person3IMG from "../../../assets/images/person-3.jpg";
import {
    clearModalContent,
    setModalContent,
} from "src/redux/modules/modalEvent";
import MatchingAssistanceModalContent from "./MatchingAssistanceModalContent";
import { useIsMobile } from "src/latest/src/hooks";
import { noop } from "react-bootstrap-typeahead/types/utils";
import { Typography } from "src/latest/src/components";

type Props = {
    className?: string;
    buttonAction: (concernText: string) => void;
    buttonLabel: string;
    variant?: string;
    title?: string;
    subtitle?: string;
    onClick?: () => void;
    isType?: boolean;
    isProcessing?: boolean;
    avatarInitialsColor?: string;
};

export default function HelpMeFindATherapist({
    className = "",
    variant,
    buttonAction,
    buttonLabel,
    title,
    subtitle,
    onClick = noop,
    isType,
    isProcessing,
    avatarInitialsColor = "#354354",
}: Props) {
    const dispatch = useDispatch();
    const isFromMobile = useIsMobile();

    const handleContinue = (concernText: string) => {
        buttonAction(concernText);
        dispatch(clearModalContent());
    };

    const handleGoBack = () => {
        dispatch(clearModalContent());
    };

    const openMatchingAssistanceModal = () => {
        dispatch(
            setModalContent({
                modalContent: (
                    <MatchingAssistanceModalContent
                        onContinue={handleContinue}
                        onGoBack={ handleGoBack}
                    />
                ),
                title: (
                    <Typography color="color-28" variant="size-20">
                        Matching Assistance
                    </Typography>
                ),
                className: "matching-assistance-modal",
                size: "sm",
                isGeneralPopup: true,
                backDrop: "static",
            })
        );
    };

    return (
        <div
            className={`help-me-find-therapist-card text-center ${className} bg-${
                variant || "white"
            } ${isType ? "cursor-pointer" : ""}`}
            onClick={() => onClick()}
        >
            <div
                className="help-me-find-therapist-card__images-container"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingLeft: isFromMobile ? "100px" : "80px",
                    paddingRight: isFromMobile ? "100px" : "80px",
                }}
            >
                <div className="help-me-find-therapist-card__img-container mx-auto">
                    <Avatar
                        photoUrl={Person1IMG}
                        size={isFromMobile ? "50px" : "100px"}
                        initialsColor={avatarInitialsColor}
                    />
                </div>
                <div
                    style={{ position: "absolute", zIndex: 1 }}
                    className="help-me-find-therapist-card__center-img-container mx-auto"
                >
                    <Avatar
                        photoUrl={Person2IMG}
                        size={isFromMobile ? "60px" : "120px"}
                        initialsColor={avatarInitialsColor}
                    />
                </div>
                <div className="help-me-find-therapist-card__img-container mx-auto">
                    <Avatar
                        photoUrl={Person3IMG}
                        size={isFromMobile ? "50px" : "100px"}
                        initialsColor={avatarInitialsColor}
                        className={isFromMobile ? "ms-5" : ""}
                    />
                </div>
            </div>
            <Typography
                className="help-me-find-therapist-card__title"
                variant={isFromMobile ? "size-18" : "size-24"}
                color="color-2"
                weight="bold"
            >
                {title}
            </Typography>
            <Typography
                className="help-me-find-therapist-card__subtitle mt-3 mt-sm-3 mt-lg-4"
                variant={isFromMobile ? "size-14" : "size-18"}
                color={"color-2"}
                weight="regular"
                dangerouslySetInnerHTML={{ __html: subtitle ?? "" }}
            />

            <Button
                variant="teal"
                textSize="size-14"
                textWeight="bold"
                label={buttonLabel}
                onClick={openMatchingAssistanceModal}
                isProcessing={isProcessing}
                disabled={isProcessing}
                className={`px-5 py-3 d-block mx-auto`}
            />
        </div>
    );
}
